<template>
  <span class="skeleton" :style="style" aria-hidden="true" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

// Token-CSS shimmer placeholder. Reduced-motion safe (the shimmer animation is
// disabled under prefers-reduced-motion below).
const props = defineProps<{
  width?: string
  height?: string
  radius?: string
}>()

const style = computed(() => ({
  width: props.width || '100%',
  height: props.height || '14px',
  borderRadius: props.radius || 'var(--radius-sm)',
}))
</script>

<style scoped>
.skeleton {
  display: block;
  background: linear-gradient(
    90deg,
    var(--color-bg-subtle) 25%,
    var(--color-bg-sunk) 37%,
    var(--color-bg-subtle) 63%
  );
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
}
@keyframes skeleton-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
@media (prefers-reduced-motion: reduce) {
  .skeleton { animation: none; }
}
</style>
